const deviationColors = {
    namespaced: true,
    state: {
        deviationColorsList: [
          {
            "class":0,
            "minval": null,
            "maxval": 0,
            "primarycolor": "#ffffff",
          },
          {
            "class":1,
            "minval": 0,
            "maxval": 0,
            "primarycolor": "#ffffff",
          },
          {
            "class":2,
            "minval": 0,
            "maxval": 0,
            "primarycolor": "#ffffff",
          },
          {
            "class":3,
            "minval": 0,
            "maxval": 0,
            "primarycolor": "#ffffff",
          },
          {
            "class":4,
            "minval": 0,
            "maxval": null,
            "primarycolor": "#ffffff",
          }
        ]
    },
    mutations: {
        updateDeviatinClasses(state, newList) {
            state.deviationColors = newList;
            state.updated = true;
        }
    },
    actions: {
        getDeviationColors(context) {
          return new Promise((resolve, reject) => {
            this._vm.$traveller_http.get('/traveller/restui/system/getVehicleScheduleDeviationColorParam')
            .then( response => {
                if(response.data.value){
                  context.commit('updateDeviatinClasses' ,response.data.value )
                  resolve(response.data.value)
                }else{
                  resolve(this.state.deviationColors)
                }
            }).catch( error => {
                reject(error)
            })
          }) 
        },
        updateDeviationColors(context, newSettings) {
          return new Promise((resolve, reject) => {
              this._vm.$traveller_http.post('/traveller/restui/system/setVehicleScheduleDeviationColorParam', {"parameter":"VEHICLE_SCHEDULE_DEVIATION_COLORS", "value": newSettings, "type": "JSON"})
                  .then(response => {
                      context.dispatch('getDeviationColors');
                      resolve(response);
                  }).catch( (error) => {
                  reject(error);
              })
          });
      },
    }
}

export default deviationColors;
